import React from 'react';
import onlineIcon from '../../icons/onlineIcon.png';
import './TextContainer.css';


const TextContainer = ({ users }) => (
    <div className="textContainer">

    {
      users
        ? (
          <div>
            {/* <h1>Live Users</h1> */}
              <p>
                {users.map(({name}) => (
                  <div key={name} className="activeItem">
                    <img alt="Online Icon" src={onlineIcon}/>
                    &nbsp;
                    {name}
                  </div>
                ))}
              </p>
            </div>
        )
        : null
    }
  </div>
)
export default TextContainer;